import { sendStorageEvent } from './sendEvent';

const mapFormId = (formId) => parseInt(formId, 10);

export class FormIndexedDBRepo {
  constructor(db) {
    this.db = db;
  }

  get(formId) {
    return this.db.forms.get(mapFormId(formId));
  }

  async put(formId, form) {
    await this.db.forms.put(form, mapFormId(formId));
    sendStorageEvent(`putForm_${formId}`);
  }

  async saveValue(formId, path, value) {
    await this.db.forms.update(mapFormId(formId), { [path]: value });
    sendStorageEvent(`putForm_${formId}`);
  }

  async delete(formId) {
    await this.db.forms.delete(mapFormId(formId));
  }

  getList({ status, localStatus }) {
    if (status === undefined && localStatus === undefined) return this.db.forms.toArray();
    return this.searchList({ status, localStatus }).toArray();
  }

  getIdsList({ status, localStatus }) {
    if (status === undefined && localStatus === undefined) return this.db.forms.primaryKeys();
    return this.searchList({ status, localStatus }).primaryKeys();
  }

  searchList({ status, localStatus }) {
    return this.db.forms.where({
      ...(status !== undefined && { status }),
      ...(localStatus !== undefined && { localStatus }),
    });
  }

  async exists(formId) {
    return (await this.db.forms.get(mapFormId(formId))) !== undefined;
  }

  async updatedAt(formId) {
    return (await this.db.forms.get(mapFormId(formId))).updatedAt;
  }

  async localStatus(formId) {
    return (await this.db.forms.get(mapFormId(formId))).localStatus;
  }
}
